import { ComponentPortal } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, ContentChild, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { SimCalendarComponent } from './calendar.component';
import { ExtractDateTypeFromSelection, SIM_SINGLE_DATE_SELECTION_MODEL_PROVIDER } from './date-selection-model';
import { simDatePickerAnimations } from './datepicker-animations';
import { SimDatepickerBase, SimDatepickerControl } from './datepicker-base';
import { SimDatepickerContentBase } from './datepicker-content-base';

@Component({
  selector: 'sim-datepicker-content',
  templateUrl: './datepicker-content.component.html',
  styleUrls: ['./datepicker.component.scss'],
  animations: [simDatePickerAnimations.transformPanel, simDatePickerAnimations.fadeInCalendar],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sim-datepicker-content'
  }
})
export class SimDatepickerContentComponent<S, D = ExtractDateTypeFromSelection<S>> extends SimDatepickerContentBase<S, D> {
  @ViewChild(SimCalendarComponent) _calendar: SimCalendarComponent<D>;

  _getSelected(): D | null {
    return this._model ? ((this._model.selection as unknown) as D) : null;
  }
}

@Component({
  selector: 'sim-datepicker',
  template: '',
  exportAs: 'simDatepicker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [SIM_SINGLE_DATE_SELECTION_MODEL_PROVIDER]
})
export class SimDatepickerComponent<D> extends SimDatepickerBase<SimDatepickerControl<D>, D | null, D> {
  @ContentChild('simCalendarFooter') simCalendarFooter: TemplateRef<void>;
  protected createPortal() {
    return new ComponentPortal<SimDatepickerContentComponent<D, D>>(SimDatepickerContentComponent, this._viewContainerRef);
  }
}
